import { StrapiImageDataParameters } from '@arrived/models';

export const buildImageUrl = (imageData: StrapiImageDataParameters) => {
  return `${imageData.hash}${imageData.ext}`;
};
